<template>
  <div class="search-topic-wrap">
    <div class="top-banner">
      <p>随时随地搜索#热门话题</p>
      <p>根据搜索话题，为您匹配以下视频数据</p>
    </div>
    <router-view></router-view>
    
  </div>
</template>

<script>
export default{
    data(){
        return{
        }
    },
    methods:{
        
    }
}


</script>

<style scoped lang="less">
.search-topic-wrap {
  width: 1200px;
  margin: 0 auto;
  .top-banner {
    padding: 40px 0 0 20px;
    box-sizing: border-box;
    width: 100%;
    height: 148px;
    margin: 20px 0;
    background: url(../../assets/searchTopic/banner.png) no-repeat center;
    background-size: 100% 100%;
    p {
      margin: 0;
      padding-left: 40px;
      &:nth-of-type(1) {
        font-size: 20px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 20px;
      }
      &:nth-of-type(2) {
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.72);
      }
    }
  }
  
}
</style>
